import {
  ContactsOutlined,
} from "@ant-design/icons";
import { lazy } from "react";
import { permissionCodeConstant } from "../utils/permissionConstant";

export const installationOrderStaticPath = {
  installationOrder: "/installation/installation-order",
  createInstallationOrder: "/installation/installation-order/create",
  updateInstallationOrder: "/installation/installation-order/update",
  viewInstallationOrder: "/installation/installation-order/view",
  assignUserInstallationOrder: "/installation/installation-order/assign-user",
  myInstallationOrder: "/installation/my-installation-order",
  viewMyInstallationOrder: "/installation/my-installation-order/view",
  completeInstallationOrder: "/installation/my-installation-order/complete",
}

export const routerInstallationOrder = [
  {
    path: installationOrderStaticPath.installationOrder,
    key: installationOrderStaticPath.installationOrder,
    exact: true,
    show_menu: true,
    icon: <ContactsOutlined />,
    label: "menu.installation_management.installation_order_summary",
    component: lazy(() => import("../pages/assetInstallationManagement/installationOrder")),
    permisisonCode: permissionCodeConstant.installation_order_view,
  },
  {
    path: installationOrderStaticPath.createInstallationOrder,
    key: installationOrderStaticPath.createInstallationOrder,
    exact: true,
    show_menu: false,
    icon: <ContactsOutlined />,
    label: "menu.installation_management.create_installation_order",
    component: lazy(() => import("../pages/assetInstallationManagement/installationOrder/CreateInstallationOrder")),
    permisisonCode: permissionCodeConstant.installation_order_create,
  },
  {
    path: installationOrderStaticPath.updateInstallationOrder + "/:id",
    key: installationOrderStaticPath.updateInstallationOrder + "/:id",
    exact: true,
    show_menu: false,
    icon: <ContactsOutlined />,
    label: "menu.installation_management.update_installation_order",
    component: lazy(() => import("../pages/assetInstallationManagement/installationOrder/UpdateInstallationOrder")),
    permisisonCode: permissionCodeConstant.installation_order_update,
  },
  {
    path: installationOrderStaticPath.viewInstallationOrder + "/:id",
    key: installationOrderStaticPath.viewInstallationOrder + "/:id",
    exact: true,
    show_menu: false,
    icon: <ContactsOutlined />,
    label: "menu.installation_management.view_installation_order",
    component: lazy(() => import("../pages/assetInstallationManagement/installationOrder/ViewInstallationOrder")),
    permisisonCode: permissionCodeConstant.installation_order_view,
  },
  {
    path: installationOrderStaticPath.assignUserInstallationOrder + "/:id",
    key: installationOrderStaticPath.assignUserInstallationOrder + "/:id",
    exact: true,
    show_menu: false,
    icon: <ContactsOutlined />,
    label: "menu.installation_management.assign_technician",
    component: lazy(() => import("../pages/assetInstallationManagement/installationOrder/InstallationOrderAssignUser")),
    permisisonCode: permissionCodeConstant.installation_order_assign_user,
  },
  {
    path: installationOrderStaticPath.myInstallationOrder,
    key: installationOrderStaticPath.myInstallationOrder,
    exact: true,
    show_menu: true,
    icon: <ContactsOutlined />,
    label: "menu.installation_management.my_installation_order",
    component: lazy(() => import("../pages/assetInstallationManagement/myInstallationOrder")),
    permisisonCode: permissionCodeConstant.my_installation_order_view,
  },
  {
    path: installationOrderStaticPath.viewMyInstallationOrder + "/:id",
    key: installationOrderStaticPath.viewMyInstallationOrder + "/:id",
    exact: true,
    show_menu: false,
    icon: <ContactsOutlined />,
    label: "menu.installation_management.view_my_installation_order",
    component: lazy(() => import("../pages/assetInstallationManagement/myInstallationOrder/ViewMyInstallationOrder")),
    permisisonCode: permissionCodeConstant.my_installation_order_view,
  },
  {
    path: installationOrderStaticPath.completeInstallationOrder + "/:id",
    key: installationOrderStaticPath.completeInstallationOrder + "/:id",
    exact: true,
    show_menu: false,
    icon: <ContactsOutlined />,
    label: "menu.installation_management.complete_installation_order",
    component: lazy(() => import("../pages/assetInstallationManagement/myInstallationOrder/ConfirmCompletedInstallationOrder")),
    permisisonCode: permissionCodeConstant.my_installation_order_confirm_completed,
  },
];
